import React from 'react';
import { Brain, Heart, Home, Clock, Sparkles } from 'lucide-react';
import { Section } from './Shared';
export function ProductSection() {
  const benefits = [{
    icon: <Brain className="w-8 h-8 text-sage-dark" data-id="element-156" />,
    title: 'Desarrollo integral'
  }, {
    icon: <Heart className="w-8 h-8 text-sage-dark" data-id="element-157" />,
    title: 'Más conexión con tu bebé'
  }, {
    icon: <Home className="w-8 h-8 text-sage-dark" data-id="element-158" />,
    title: 'Actividades en casa'
  }, {
    icon: <div className="w-8 h-8 text-sage-dark" data-id="element-159" />,
    title: 'Menos pantallas'
  }, {
    icon: <Clock className="w-8 h-8 text-sage-dark" data-id="element-160" />,
    title: 'Rutinas suaves y reales'
  }, {
    icon: <Sparkles className="w-8 h-8 text-sage-dark" data-id="element-161" />,
    title: 'Estimulación sin presión'
  }];
  return <div className="bg-cream-dark border-y border-beige-muted/50" data-id="element-162">
      <Section data-id="element-163">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8 mb-12" data-id="element-164">
          {benefits.map((benefit, i) => <div key={i} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center group hover:shadow-md transition-all duration-300" data-id="element-165">
              <div className="bg-sage-light/30 p-4 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-166">
                {benefit.icon}
              </div>
              <p className="text-charcoal font-medium text-lg" data-id="element-167">
                {benefit.title}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-168">
          <p className="inline-block bg-white border border-beige-muted/50 text-charcoal text-lg font-medium px-8 py-4 rounded-full shadow-sm italic" data-id="element-169">
            Creado para mamás reales, no para rutinas perfectas.
          </p>
        </div>
      </Section>
    </div>;
}